import React, { useState } from "react";
import { Link } from 'react-router-dom';
import './PromoOdoo.css';

const DISMISS_KEY = 'promoOdooDismissed_v1';

// Promo para anfitriones: inventario formal (Odoo) para sus almacenes.
// Se puede cerrar; la elección se recuerda por versión (promoOdooDismissed_v1)
// para poder volver a mostrarla si el mensaje cambia más adelante.
const PromoOdoo = () => {
    const [visible, setVisible] = useState(() => !localStorage.getItem(DISMISS_KEY));

    if (!visible) return null;

    const cerrar = () => {
        localStorage.setItem(DISMISS_KEY, '1');
        setVisible(false);
    };

    return (
        <div className="promoOdoo">
            <div className="promoOdoo__icono">
                <svg viewBox="0 0 24 24"><path d="M21 8.5 12 4 3 8.5l9 4.5 9-4.5Z"/><path d="M3 8.5V16l9 4.5 9-4.5V8.5"/><path d="M12 13v7.5"/></svg>
            </div>
            <div className="promoOdoo__texto">
                <h3>Lleva tu almacén a un inventario de nivel empresarial</h3>
                <p>
                    Cada entrada y salida se documenta automáticamente, confirmas lo realmente recibido,
                    ubicas cada pallet por posición y tus clientes reciben notificación al instante.
                    Necesitas: tu RFC y el layout de tu almacén — nosotros hacemos el resto.
                </p>
            </div>
            <div className="promoOdoo__acciones">
                <Link to="/mensajes" className="promoOdoo__btn">Contáctanos para una demo</Link>
                <button type="button" className="promoOdoo__cerrar" onClick={cerrar} aria-label="Cerrar aviso">
                    <svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg>
                </button>
            </div>
        </div>
    );
};

export default PromoOdoo;
